module.exports = __webpack_public_path__ + "img/arrow-right-hover.5862a806.svg";